import React from "react";
import { connect } from "react-redux";
//import ConsoleSeenRolloutButton from "./ConsoleSeenRolloutButton";
import moment from "moment";

class ConsoleViewRollout extends React.Component {
  renderBlip(blip, index) {
    if (blip.type === "message") {
      return (
        <div key={index}>
          {blip.content.map((line, i) => {
            return (
              <div key={i}>
                {line}
              </div>
            );
          })}
        </div>
      );
    }

    return null;
  }

  renderCurrentRolloutBlip() {
    //Only show this if we have rolloutData
    if (this.props.rolloutData && this.props.rolloutData.length > 0) {
      return (
        <div className="ConsoleViewRollout-current">
          {this.props.rolloutData.map((blip, i) => {
            return this.renderBlip(blip, i);
          })}

          {/*<ConsoleSeenRolloutButton rolloutId={this.props.rolloutId} />*/}
        </div>
      );
    }

    return (
      <div className="ConsoleViewRollout-current">Waiting for Rollout...</div>
    );
  }

  renderHistoryEntry(entry, i) {
    return (
      <div key={i} className="ConsoleViewRollout-history-entry">
        <div className="ConsoleViewRollout-history-entry-id">
          {moment(entry.timestamp).format("h:mm:ss a")}
        </div>
        <div>
          {entry.rolloutPayload.map((blip, i) => {
            return this.renderBlip(blip, i);
          })}
        </div>
      </div>
    );
  }

  render() {
    const isShowingCurrentRollout =
      this.props.rolloutData && this.props.rolloutData.length > 0;

    return (
      <div className="ConsoleViewRollout">
        {this.renderCurrentRolloutBlip()}

        <div className="ConsoleViewRollout-history">
          {this.props.rolloutHistory
            .filter((entry, i) => {
              if (isShowingCurrentRollout && i === 0) {
                return false;
              }

              return true;
            })
            .map((entry, i) => this.renderHistoryEntry(entry, i))}
        </div>
      </div>
    );
  }
}

ConsoleViewRollout.propTypes = {
  //someRequiredProp: React.PropTypes.string.isRequired
};

ConsoleViewRollout.defaultProps = {};

export default connect((state, props) => {
  return {
    rolloutId: state.battle.rolloutId,
    rolloutData: state.battle.rolloutData,
    rolloutHistory: state.battle.rolloutHistory
  };
})(ConsoleViewRollout);



// WEBPACK FOOTER //
// ./src/battle/ConsoleViewRollout.js